module.exports = __webpack_public_path__ + "static/media/winner_result.4e47fe7c.png";